import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { auth as AuthGen } from '@valvur/shared-grpc';
import { InitialsPipe } from '../../../../shared/pipes/initials.pipe';
import { FamilyKidsService } from '../../../parent-family/services/family-kids.service';

@Component({
  selector: 'app-user-card',
  standalone: true,
  imports: [CommonModule, TranslatePipe, InitialsPipe],
  templateUrl: './user-card.component.html',
  styleUrl: './user-card.component.scss',
})
export class UserCardComponent {
  #familyKids = inject(FamilyKidsService);

  user = input<AuthGen.User>();
  /** Avatar-only layout for compact headers (mobile). */
  compact = input(false);

  readonly children = this.#familyKids.children;
  readonly kidsCount = computed(() => this.children().length);
}
